import {
  ContentBlock,
  Stack,
  TabPanels,
  TabsProvider,
  TabPanel,
  Box,
  PageBlock,
  Divider,
  Hidden,
  Page,
} from 'braid-design-system';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import Header from 'src/components/Header/Header';
import { SiteWideFooter } from 'src/components/SiteWideFooter';
import { VerifyEmailAlert } from 'src/components/VerifyEmailAlert';
import type { StoreProps } from 'src/store';

import ListingsTab from './components/ListingsTab/ListingsTab';
import Navigation from './components/Navigation/Navigation';
import ProductsTab from './components/ProductsTab/ProductsTab';
import ToolsTab from './components/ToolsTab/ToolsTab';

const PAGE_WIDTH = 'large';
const TAB_WIDTH = 'medium';

const Dashboard = () => {
  const paid = useSelector(({ account }: StoreProps) => account.paid);
  const [searchParams] = useSearchParams();
  const defaultSelectedTab =
    searchParams.get('selectedTab') ?? (paid ? 'listings' : 'products');
  const [selectedTab, setSelectedTab] = useState(defaultSelectedTab);

  const getWidth = selectedTab === 'products' ? PAGE_WIDTH : TAB_WIDTH;

  return (
    <Page footer={<SiteWideFooter />} footerPosition="belowFold">
      <Header title="Sell your business" />

      <Hidden below="tablet">
        <Divider />
      </Hidden>

      <VerifyEmailAlert width={getWidth} />

      <Box paddingTop="xlarge">
        <PageBlock width={PAGE_WIDTH}>
          <TabsProvider
            id="dashboardTabs"
            selectedItem={selectedTab}
            onChange={(index, item) => setSelectedTab(String(item))}
          >
            <Stack space="medium">
              <ContentBlock width={TAB_WIDTH}>
                <Navigation paid={paid} />
              </ContentBlock>

              <TabPanels>
                <TabPanel item="listings">
                  <ContentBlock width={TAB_WIDTH}>
                    <ListingsTab />
                  </ContentBlock>
                </TabPanel>

                <TabPanel item="tools">
                  <ContentBlock width={TAB_WIDTH}>
                    <ToolsTab />
                  </ContentBlock>
                </TabPanel>

                <TabPanel item="products">
                  {/* Note there's no <ContentBlock /> here. We want our products
                      table to bleed the full page width */}
                  <ProductsTab />
                </TabPanel>
              </TabPanels>
            </Stack>
          </TabsProvider>
        </PageBlock>
      </Box>
    </Page>
  );
};
export default Dashboard;
